import React, { useState } from "react";
import BarekamText from "../../../components/text";
import { useAppSelector } from "../../../../redux/store";
import Message from "../../../components/message";
import { MessageSections } from "../../../components/message/message";
import { DeliveryAddressSelectorContainer } from "./styled";
import { OrderPopupCardTitle } from "../styled";
import { OrderModel } from "../../../shared/models/order/order-item.model";
import { UserAddress } from "../../../shared/models/user/user-address";
import { WarehouseModel } from "../../../shared/models/order/warehouse.model";
import { BarekamIcon } from "../../../components/icon/barekam-icon";
import { OrderIcons } from "../../../components/icon/variants";
import { SingleSelectItem } from "../../../components/single-select-item/single-select-item";
import { AdditionalServiceDialog } from "../additional-services/additional-service-dialog/additional-service-dialog";
import { AdditionalServiceModel } from "../../../shared/models/order/additional-service.model";

export const DeliveryAddressSelector = ({ order, isReadonly, isNewOrder, updateData, onSelect }: DeliveryAddressSelectorProps) => {
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);

    const { additionalServices } = useAppSelector(state => state.staticDataReducer);

    const destination = updateData && updateData?.shippingInfo
        ? updateData.shippingInfo?.homeDeliveryAddress || updateData.shippingInfo.destinationWarehouse
        : order.shippingInfo.homeDeliveryAddress || order.shippingInfo.destinationWarehouse;

    const homeDelivery = additionalServices.find(service => service.additionalServiceId === 5);

    function getTopLabel() {
        if (destination?.hasOwnProperty('warehouseId')) {
            const warehouse = destination as WarehouseModel;

            return <Message messageKey={warehouse.city} sectionId={MessageSections.MAIN} />;
        } else {
            const userAddress = destination as UserAddress;

            return userAddress.name
        }
    }

    function getLowerLabel() {
        if (destination?.hasOwnProperty('warehouseId')) {
            const warehouse = destination as WarehouseModel;

            return warehouse.addressLine1;
        } else {
            const userAddress = destination as UserAddress;

            return [
                // address.country,
                // address.city,
                userAddress?.province?.name,
                userAddress?.region?.name,
                userAddress.street,
                userAddress.building,
                userAddress.entrance,
                userAddress.floor,
                userAddress.apartment]
                .filter(value => !!value)
                .join(', ');
        }
    }

    function getRightLabel() {
        if (destination?.hasOwnProperty('warehouseId')) {
            return ''
        } else {
            const homeDeliveryService: AdditionalServiceModel = (updateData && updateData.additionalService || order.additionalService)
                .find((service: AdditionalServiceModel) => service.additionalServiceId === 5);

            return <>{homeDeliveryService.price || '?'}&nbsp;AMD</>;
        }
    }

    function changeOrderAddress() {
        setDialogOpen(true);
    }

    function handleDialogClosed(confirmed: boolean, existingOrderUpdates: any) {
        if (confirmed) {
            onSelect(existingOrderUpdates);
        }

        setDialogOpen(false);
    }

    const AddressIcon = () => {
        if (destination?.hasOwnProperty('warehouseId')) {
            return (
                <BarekamIcon variant={OrderIcons.warehouseDelivery} size={{ width: '2rem', height: '2rem' }} />
            )
        } else {
            return (
                <BarekamIcon variant={OrderIcons.homeDelivery} size={{ width: '2rem', height: '2rem' }} />
            )
        }
    }

    return (
        <DeliveryAddressSelectorContainer style={{ padding: isNewOrder ? 0 : '1rem' }}>
            <OrderPopupCardTitle>
                <BarekamText variant={'m'} bold>
                    <Message messageKey={'delivery_address'} sectionId={MessageSections.ORDERS} />
                </BarekamText>
            </OrderPopupCardTitle>

            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%' }}>
                <SingleSelectItem Icon={AddressIcon()}
                    TopLabel={
                        <BarekamText variant={'m'} fontWeight={500} style={{ height: '1.2rem' }}>
                            {getTopLabel()}
                        </BarekamText>
                    }
                    LowerLabel={
                        <BarekamText variant={'s'} fontWeight={600} opaque>
                            {getLowerLabel()}
                        </BarekamText>
                    }
                    RightLabel={
                        <BarekamText variant={'m'} fontWeight={500}>
                            {getRightLabel()}
                        </BarekamText>
                    }
                    selected={true} />

                {/*{isReadonly*/}
                {/*    ? ''*/}
                {/*    : <BarekamButton type={SimpleButtons.LINK} onClick={() => changeOrderAddress()}>*/}
                {/*        <BarekamIcon variant={IconVariants.edit}/>*/}
                {/*    </BarekamButton>*/}
                {/*}*/}
            </div>

            {homeDelivery && dialogOpen
                ? <AdditionalServiceDialog open={dialogOpen}
                    order={order}
                    updateData={updateData}
                    service={homeDelivery}
                    additionalServiceData={{}}
                    isNewOrder={isNewOrder}
                    handleClose={handleDialogClosed} />
                : <></>
            }
        </DeliveryAddressSelectorContainer>
    );
}

interface DeliveryAddressSelectorProps {
    order: OrderModel,
    isReadonly?: boolean,
    isNewOrder: boolean,
    updateData?: { [key: string]: any },
    onSelect: (updateData: { [key: string]: any }) => void,
}
